import React from 'react';

interface LoadingScreenProps {
  /** Optional label for assistive technologies */
  message?: string;
  /** Optional secondary label (kept for backwards compatibility) */
  submessage?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Carregando...',
  submessage,
}) => {
  const ariaLabel = submessage ? `${message} - ${submessage}` : message;

  return (
    <div className="flex min-h-screen items-center justify-center bg-transparent">
      <div className="relative inline-flex h-8 w-8 items-center justify-center">
        <div className="absolute inset-0 rounded-full border border-gray-600/60 dark:border-gray-400/50" />
        <div className="absolute inset-0 rounded-full border border-gray-200 border-t-transparent dark:border-gray-200/90 animate-spin" />
        <span className="sr-only">{ariaLabel}</span>
      </div>
    </div>
  );
};

